var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"breadStyle"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},_vm._l((_vm.data),function(v,i){return _c('el-breadcrumb-item',{attrs:{"to":{ path: v.link }}},[_vm._v(_vm._s(v.name))])}),1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }